import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { AppConfigProvider } from '../../providers/app-config/app-config';
/**
 * Generated class for the SettingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-setting',
  templateUrl: 'setting.html'
})
export class SettingPage {
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private alertCtrl: AlertController,
    private storage: Storage
  ) {}

  user_id: number;
  password: string;

  async ionViewWillEnter() {
    this.user_id = await this.storage.get('user_id');
  }

  async showConfirm() {
    this.alert('Are you sure?', 'You are about to update your password.', () => {
      console.log('Agree clicked');

      this.http
        .post(this.appConfig.apiUrl() + 'index.php/api/login/update', {
          user_id: this.user_id,
          password: this.password,
          app_key: this.appConfig.appKey()
        })
        .subscribe(
          (res: any) => {
            this.alertMessage('Success', 'Successfully updated user password.');
          },
          err => {
            this.alertMessage('Error', 'Failed to update password');
          }
        );
    }, () => {
      console.log('NO');
    });
    
  }

  alert(title, message, yesHandler, noHandler) {
    const confirm = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        { text: 'No', handler: () => noHandler() },
        { text: 'Yes', handler: () => yesHandler() }
      ]
    });
    confirm.present();
  }

  alertMessage(title, subtitle) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: subtitle,
      buttons: ['Dismiss']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/setting/setting.ts